import React from 'react';
import { cn } from './cn';

/**
 * IconShape — hộp chứa icon tròn theo intent (brand/gray/success/danger/warning).
 * size: xs|sm|md|lg|xl. Truyền icon component qua prop `icon`.
 */
const SIZES = {
  xs: { box: 'w-6 h-6', icon: 'w-3.5 h-3.5' },
  sm: { box: 'w-8 h-8', icon: 'w-4 h-4' },
  md: { box: 'w-10 h-10', icon: 'w-5 h-5' },
  lg: { box: 'w-12 h-12', icon: 'w-6 h-6' },
  xl: { box: 'w-14 h-14', icon: 'w-7 h-7' },
};

const VARIANTS = {
  brand: 'bg-brand-softer text-brand-fg-strong',
  gray: 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-300',
  success: 'bg-emerald-50 text-emerald-600 dark:bg-emerald-950 dark:text-emerald-400',
  danger: 'bg-red-50 text-red-600 dark:bg-red-950 dark:text-red-400',
  warning: 'bg-amber-50 text-amber-600 dark:bg-amber-950 dark:text-amber-400',
};

export function IconShape({ icon: Icon, variant = 'brand', size = 'md', shape = 'circle', className, ...props }) {
  const s = SIZES[size] || SIZES.md;
  return (
    <span
      className={cn(
        'inline-flex items-center justify-center flex-shrink-0',
        shape === 'circle' ? 'rounded-full' : 'rounded-xl',
        s.box,
        VARIANTS[variant] || VARIANTS.brand,
        className
      )}
      {...props}
    >
      {Icon ? <Icon className={s.icon} aria-hidden="true" /> : null}
    </span>
  );
}

export default IconShape;
